import React, { useState, useEffect } from "react";
import SelectDropdown from "./SelectDropdown";

const Criteria = ({ score, setCriteriaChecked, setShouldWatch }) => {
  const [loading, setLoading] = useState(true);

  const [formValid, setFormValid] = useState(false);

  const [minGoals, setMinGoals] = useState("");
  const [maxGoals, setMaxGoals] = useState("");
  const [loseBy, setLoseBy] = useState("");
  const [watchDraw, setWatchDraw] = useState("");

  const homeTeam = score?.response[0]?.teams.home.name;
  const awayTeam = score?.response[0]?.teams.away.name;

  const options = {
    minGoals: ["1", "2", "3", "4", "5+"],
    maxGoals: [`${homeTeam}`, `${awayTeam}`, "either team"],
    loseBy: ["1", "2", "3", "4", "5+"],
    watchDraw: ["No", "Yes"],
  };

  const handleCheckCriteria = () => {
    let shouldWatch = true;

    // Check minGoals
    if (minGoals !== "") {
      shouldWatch =
        shouldWatch &&
        score.response[0].goals.home + score.response[0].goals.away >=
          parseInt(minGoals);
    }

    // Check maxGoals and loseBy
    if (maxGoals !== "" && loseBy !== "") {
      const goalsDiff =
        maxGoals === homeTeam
          ? score.response[0].goals.away - score.response[0].goals.home
          : maxGoals === awayTeam
          ? score.response[0].goals.home - score.response[0].goals.away
          : Math.abs(
              score.response[0].goals.home - score.response[0].goals.away
            );

      shouldWatch =
        shouldWatch &&
        (loseBy === "5+" || parseInt(loseBy) >= Math.abs(goalsDiff));
    }

    // Check watchDraw
    if (watchDraw !== "") {
      shouldWatch =
        shouldWatch &&
        (watchDraw === "Yes" ||
          score.response[0].goals.home !== score.response[0].goals.away);
    }

    // console.log(shouldWatch ? "Watch" : "Do not watch");
    setCriteriaChecked(true);
    setShouldWatch(shouldWatch);
    window.scrollTo({
      top: document.getElementById('scoreboard').offsetTop,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    if (score) {
      setLoading(false);
    }
  }, [score]);

  useEffect(() => {
    const formValues = [minGoals, maxGoals, loseBy, watchDraw];
    const filledValues = formValues.filter((value) => value !== "");
    const atLeastOneFilled = filledValues.length > 0;

    setFormValid(atLeastOneFilled);
  }, [minGoals, maxGoals, loseBy, watchDraw]);

  if (loading) {
    return <div></div>;
  }

  return (
    <div className="flex-column section-container">
      <div className="flex-column">
        <h3>Let us know your criteria, we'll decide</h3>
      </div>
      <div className="flex-column form-outer-wrap">
        <span className="note">
          *Leave questions blank to exclude them from the criteria
        </span>
        <div className="flex-column form-inner-wrap">
          <SelectDropdown
            label="Min goals you want to see in total?"
            options={options.minGoals}
            value={minGoals}
            width="small"
            onChange={(e) => setMinGoals(e.target.value)}
          />
          <div className="flex-row multi-criteria-wrap">
            <div className="flex-row multi-label-gap">
              <SelectDropdown
                label="Max goals you could watch"
                options={options.maxGoals}
                value={maxGoals}
                width="large"
                onChange={(e) => setMaxGoals(e.target.value)}
              />
              <label>lose by?</label>
            </div>
            <SelectDropdown
              options={options.loseBy}
              value={loseBy}
              width="small"
              onChange={(e) => setLoseBy(e.target.value)}
            />
          </div>
          <SelectDropdown
            label="Would you watch a draw?"
            options={options.watchDraw}
            value={watchDraw}
            width="small"
            onChange={(e) => setWatchDraw(e.target.value)}
          />
        </div>
      </div>
      <div className="flex-column form-submit">
        <span className="form-submit-note">
          If all conditions are met, you should watch the game
        </span>
        <button
          className="button-primary"
          onClick={handleCheckCriteria}
          disabled={!formValid}
        >
          Check criteria
        </button>
      </div>
    </div>
  );
};

export default Criteria;
